/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reading_Labels_TitleInputs */

const en_reading_labels_title = /** @type {(inputs: Reading_Labels_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What to read`)
};

const es_reading_labels_title = /** @type {(inputs: Reading_Labels_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qué leer`)
};

/**
* | output |
* | --- |
* | "What to read" |
*
* @param {Reading_Labels_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const reading_labels_title = /** @type {((inputs?: Reading_Labels_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reading_Labels_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_reading_labels_title(inputs)
	return en_reading_labels_title(inputs)
});